import { getFirebase } from './firebase';
var storage = getFirebase().storage().ref();
export default storage;